module.exports = __webpack_public_path__ + "img/empty.18903e48.png";